import React from 'react';
import Seo from '../components/Seo';
import founderImg from '../assets/founder.jpeg';
import drPurushottamImg from '../assets/dr-purushottam-naidu.jpeg';

const LinkedInIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const TEAM = [
  {
    name: 'CA Narasimhaswamy Basavani',
    role: 'Founder & CEO',
    img: founderImg,
    bio: 'CA with 8+ years in financial markets. Trainer, visiting faculty, and mentor. Founded InvFly to deliver structured, concept-first market education.',
    li: 'https://www.linkedin.com/in/ca-narasimha-swamy-basavani-65443815a/',
    isFounder: true,
  },
  {
    name: 'Dr. Purushottam Naidu',
    role: 'Academic Advisor',
    img: drPurushottamImg,
    bio: "PhD in Finance with decades in academia. Guides InvFly's curriculum alignment with NEP 2020 and university education standards.",
    li: '#',
  },
];

const TargetIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
  </svg>
);
const TrendingIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
  </svg>
);
const BookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
  </svg>
);

const VISION = [
  { icon: <TargetIcon />, title: 'Clarity over Confusion', desc: 'Structured learning eliminates market confusion and builds genuine understanding — one concept at a time.' },
  { icon: <TrendingIcon />, title: 'Discipline over Emotions', desc: 'Success in markets comes from disciplined decision-making, not emotional reactions or tips.' },
  { icon: <BookIcon />, title: 'Education First', desc: 'Real market success starts with understanding fundamentals — not shortcuts, signals, or social media noise.' },
];

const STORY_PARAS = [
  'InvFly was born from a simple observation: most people entering the stock market lack structured guidance. They learn from scattered videos, random tips, and social media noise — creating confusion, emotional decisions, and often, disappointment.',
  'Our founder, CA Narasimhaswamy Basavani, with his extensive experience in financial markets and education, recognized the need for a different approach — one that prioritizes understanding over quick profits, discipline over emotions, and structure over randomness.',
  'Today, InvFly stands committed to concept-first financial education. Real market success comes from clarity, not guesswork. From discipline, not impulsiveness. From learning, not shortcuts.',
];

const About = () => (
  <>
    <Seo
      title="About — InvFly"
      description="Learn about InvFly's mission to deliver structured, concept-first financial market education for Indian learners."
    />

    <div className="ph">
      <div className="container">
        <div className="ph-tag">Our Story</div>
        <div className="ph-title">About <span className="txt-ac">InvFly</span></div>
        <p className="ph-desc">Founded with a vision to deliver structured, concept-first market education focused on clarity and discipline.</p>
      </div>
    </div>

    <section className="sec">
      <div className="container">
        {/* Team */}
        <div className="sh">
          <div className="s-tag">Team</div>
          <div className="s-title">Our Team</div>
        </div>
        <div className="team-grid">
          {TEAM.map((p, i) => (
            <div key={i} className="team-card">
              {p.img
                ? <img src={p.img} alt={p.name} className="team-av" />
                : <div className="team-av-i">{p.name[0]}</div>
              }
              {p.isFounder && <span className="tag tag-g" style={{ marginBottom: '8px' }}>Founder</span>}
              <div className="team-name">{p.name}</div>
              <div className="team-role">{p.role}</div>
              <div className="team-bio">{p.bio}</div>
              <div className="team-acts">
                <a href={p.li} target="_blank" rel="noopener noreferrer" className="btn-s" style={{ fontSize: '12px', padding: '6px 12px' }}>
                  <LinkedInIcon /> LinkedIn
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="divider"></div>

        {/* Vision */}
        <div className="sh">
          <div className="s-tag">Vision</div>
          <div className="s-title">Our Vision</div>
        </div>
        <div className="vision-grid">
          {VISION.map((v, i) => (
            <div key={i} className="vis-card">
              <div className="vis-icon">{v.icon}</div>
              <div className="vis-title">{v.title}</div>
              <div className="vis-desc">{v.desc}</div>
            </div>
          ))}
        </div>

        <div className="divider"></div>

        {/* Mission */}
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: '36px', marginBottom: '24px' }}>
          <div className="s-tag" style={{ marginBottom: '10px' }}>Mission</div>
          <div style={{ fontFamily: 'var(--fd)', fontSize: '20px', fontWeight: '700', color: 'var(--text)', marginBottom: '16px', letterSpacing: '-.02em' }}>Our Mission</div>
          <p style={{ fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.85' }}>
            InvFly was founded to deliver structured, concept-first market education focused on clarity and discipline. We aim to empower individuals with knowledge and skills to navigate financial markets confidently and responsibly — without relying on tips, shortcuts, or external signals.
          </p>
        </div>

        {/* Story */}
        <div className="sh" style={{ marginTop: '40px' }}>
          <div className="s-tag">Background</div>
          <div className="s-title">The InvFly Story</div>
        </div>
        <div style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: '32px', display: 'flex', flexDirection: 'column', gap: '14px' }}>
          {STORY_PARAS.map((p, i) => (
            <p key={i} style={{ fontSize: '14px', color: 'var(--text-2)', lineHeight: '1.85' }}>{p}</p>
          ))}
        </div>

      </div>
    </section>
  </>
);

export default About;
